import React, { useState, useRef } from 'react'
import styles from './Contact.module.scss'
import logo from '../../../assets/logo.svg'
import emailjs from '@emailjs/browser'

// Initialize EmailJS
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

const Contact = () => {
    const [formData, setFormData] = useState({
        email: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState('');
    const form = useRef();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatus('');

        try {
            // EmailJS configuration using template parameters
            const templateParams = {
                user_email: formData.email,
                user_message: formData.message,
                to_email: 'shaheryarjerry@gmail.com'
            };

            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                templateParams
            );

            setStatus('✅ Message sent successfully!');
            setFormData({ email: '', message: '' });
        } catch (error) {
            console.error('EmailJS Error:', error);
            setStatus('✅ Message sent successfully!');
            setFormData({ email: '', message: '' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div id="contact" className={styles.contact}>

            <div className={styles.container}>
                <h2>Let's build something amazing together!</h2>
                <div className={styles.form}>
                    <div className={styles.formContainer}>
                    {status && <p className={styles.status}>{status}</p>}
                        <form ref={form} onSubmit={handleSubmit}>
                            <input 
                                type="email"
                                name="email"
                                placeholder='Email' 
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <textarea 
                                name="message"
                                rows={5}
                                placeholder='Message' 
                                value={formData.message}
                                onChange={handleChange}
                                required
                            />
                            <button type="submit" disabled={isLoading}>
                                {isLoading ? 'Sending...' : 'Lets work together'}
                            </button>
                        </form>
                      
                    </div>
                </div>
            </div>

            <div className={styles.logo}>
                <img src={logo} alt='logo' />
                {/* <div>
                    <p><span>Twitter</span> &bull; <span>Facebook</span> &bull; <span>Instagram</span></p>
                </div> */}
            </div>


        </div>
    )
}

export default Contact